import * as React from 'react';

export const lpTopicMap = {
	helpdesk: 'helpdesk'
};

export const topSectionLogo = (
	<img
		src='https://static.wixstatic.com/shapes/dba05e_e48ab05d188d48bd9e3285db5e249d8f.svg'
		alt='wix answers logo'
	/>
);

export const topSectionFormTitle = (
	<div>
		<div className='mk-signup-form-title'>Create your free account:</div>
		<div className='mk-signup-form-subtitle'>Sign up for a free trial of Wix Answers.<br /> No credit card required.</div>

	</div>
);

export const MkSignupformCta = 'Start Your Wix Answers Trial';

export const topSectionFormIcons = (
	<div className='mk-signup-top-section-form-icons'>
		<div className='mk-signup-form-icons-row'>
			<div className='mk-signup-form-icon'>
				<img src='https://static.wixstatic.com/shapes/dba05e_536a85a32933402886655e0f7da1cc43.svg' alt='myheritage'/>
			</div>
			<div className='mk-signup-form-icon'>
				<img src='https://static.wixstatic.com/shapes/dba05e_f96491fb5ad94e099ef0b9d21ec9a83c.svg' alt='yotpo'/>
			</div>
			<div className='mk-signup-form-icon'>
				<img src='https://static.wixstatic.com/shapes/dba05e_d43aac65a7da4796a7a8f40c97aca0bf.svg' alt='rakuten viber'/>
			</div>
		</div>
		<div className='mk-signup-form-icons-row'>
			<div className='mk-signup-form-icon'>
				<img src='https://static.wixstatic.com/shapes/dba05e_ae9ade2b9a55438b9a931d437154017b.svg' alt='gettyimages'/>
			</div>
			<div className='mk-signup-form-icon'>
				<img src='https://static.wixstatic.com/shapes/dba05e_8bd6c66ac9ed4d9096ff35fde63e858b.svg' alt='sisense'/>
			</div>
			<div className='mk-signup-form-icon'>
				<img src='https://static.wixstatic.com/shapes/dba05e_f2fce63606f64ea598421aa86b78ed24.svg' alt='guesty'/>
			</div>
		</div>
	</div>
);

export const topSectionTitle = (topic: string) => `Simple, powerful ${(lpTopicMap as any)[topic] || 'customer support'} software.`;

export const topSectionSubtitle =
	'Improve customer experiences with a 360 view of managed and self-service support.';

export const topSectionMainImg = (
	<img
		src='https://static.wixstatic.com/media/dba05e_5bc2839c6e9d4a80a82df5deb985ca18~mv2.png'
		alt='wix answers'
	/>
);

export const topSectionListTitle = (topic: string) => (
	<div className='mk-signup-top-section-list-title'>
		{`Discover how Wix Answers ${(lpTopicMap as any)[topic] || 'customer support'} software can help you:`}
	</div>
);

export const topSectionList = (
	<ul className='mk-signup-top-section-list'>
		<li>Manage and answer customer tickets from all channels</li>
		<li>
			Decrease response time with automated responses and suggested
			articles
		</li>
		<li>
			Easily understand top customer concerns to improve your service or
			product
		</li>
		<li>Start your self-service knowledge base to deflect tickets</li>
	</ul>
);

export const socialProofTitle = (
	<div className='mk-signup-social-proof-title'>
		A proud customer support software leader on G2:
	</div>
);

export const socialProofBadges = (
	<div className='mk-signup-social-proof-badges'>
		<a title='BEST Customer Service Products 2021' href='https://www.g2.com/products/wixanswers-com/reviews?utm_source=rewards-badge' target='_blank'>
			<img className='mk-signup-social-proof-badge-img' alt='BEST Customer Service Products 2021' src='https://images.g2crowd.com/uploads/medal/image/68/7592d1b68eaee7837765da95654b587c.svg' />
		</a>
		<a title='BEST Software Products 2021' href='https://www.g2.com/products/wixanswers-com/reviews?utm_source=rewards-badge' target='_blank'>
			<img className='mk-signup-social-proof-badge-img' alt='BEST Software Products 2021' src='https://images.g2crowd.com/uploads/medal/image/83/68ddbcadecf986a0fca412b12d3494f4.svg' />
		</a>
		<a title='Users love WixAnswers.com on G2' href='https://www.g2.com/products/wixanswers-com/reviews?utm_source=rewards-badge' target='_blank'>
			<img className='mk-signup-social-proof-badge-img-center' alt='Users love WixAnswers.com on G2' src='https://my.g2.com/assets/product-badges/users-love-us-2008b519df49af90dcfa7db4b5fe13c8ec24ced0348f0a6bd039711ad8bbffc7.svg' />
		</a>
		<a title='WixAnswers.com is a leader in Customer Self-Service on G2' href='https://www.g2.com/products/wixanswers-com/reviews?utm_source=rewards-badge' target='_blank'>
			<img className='mk-signup-social-proof-badge-img' alt='WixAnswers.com is a leader in Customer Self-Service on G2' src='https://images.g2crowd.com/uploads/report_medal/image/1331/medal.svg' />
		</a>
		<a title='WixAnswers.com is a leader in Small-Business Help Desk on G2' href='https://www.g2.com/products/wixanswers-com/reviews?utm_source=rewards-badge' target='_blank'>
			<img className='mk-signup-social-proof-badge-img' alt='WixAnswers.com is a leader in Small-Business Help Desk on G2' src='https://images.g2crowd.com/uploads/report_medal/image/1328/medal.svg' />
		</a>
	</div>
);

const socialProofReview = (link: string, title: string, quote: string) => (
	<a href={link} target='_blank' className='mk-signup-social-proof-review'>
		<div className='mk-signup-social-proof-rating'>
			<div className='mk-social-proof-rating-star' />
			<div className='mk-social-proof-rating-star' />
			<div className='mk-social-proof-rating-star' />
			<div className='mk-social-proof-rating-star' />
			<div className='mk-social-proof-rating-star' />
		</div>
		<div className='mk-signup-social-proof-rating-title'>
			{title}
		</div>
		<div className='mk-signup-social-proof-rating-quote'>
			{quote}
		</div>

	</a>
);

export const socialProofReviews = (
	<div className='mk-signup-social-proof-reviews'>
		{socialProofReview('https://www.g2.com/products/wixanswers-com/reviews/wixanswers-com-review-4503137', 'Natasha A  |  Mid-Market', `"Super easy to use & intuitive ticketing system for customer support"`)}
		<div className='mk-signup-social-proof-divider' />
		{socialProofReview('https://www.g2.com/products/wixanswers-com/reviews/wixanswers-com-review-4481386', 'Jonathan M  |  Mid-Market', `"Best ticketing system I used so far"`)}
		<div className='mk-signup-social-proof-divider' />
		{socialProofReview('https://www.g2.com/products/wixanswers-com/reviews/wixanswers-com-review-4341748', 'Maor M  |  Mid-Market', `"An amazing corporate tool that has made me much more productive than before"`)}
	</div>
);

export const bottomSectionTitle = (
	<div className='mk-signup-bottom-section-title'>About Wix Answers:</div>
);

export const bottomSectionText = (
	<div className='mk-signup-bottom-section-text'>
		Wix Answers is redefining customer support with a platform purpose-built
		to meet the needs of a scaling company. Manage your entire support
		operation with a full suite of products.
	</div>
);

export const bottomSectionIconsContainer = (
	<div className='mk-signup-bottom-section-icons-container'>
		<div className='mk-signup-icon'>
			<div className='mk-signup-icon-img'>
				<img
					src='https://static.wixstatic.com/shapes/dba05e_098f6fb94a53474896627f55538527de.svg'
					alt='call-center'
				/>
			</div>
			<div>Call Center</div>
		</div>
		<div className='mk-signup-icon'>
			<div className='mk-signup-icon-img'>
				<img
					src='https://static.wixstatic.com/shapes/dba05e_043661f430f84b6081178a4edd80743e.svg'
					alt='ticketing-system'
				/>
			</div>
			<div>Ticketing</div>
		</div>
		<div className='mk-signup-icon'>
			<div className='mk-signup-icon-img'>
				<img
					src='https://static.wixstatic.com/shapes/dba05e_4a588b49a68c4571a555b379bdb27760.svg'
					alt='help-widget'
				/>
			</div>
			<div>Help Widget</div>
		</div>
		<div className='mk-signup-icon'>
			<div className='mk-signup-icon-img'>
				<img
					src='https://static.wixstatic.com/shapes/dba05e_0f8d213cd4a04d4b8eb90c283573cef5.svg'
					alt='live-chat'
				/>
			</div>
			<div>Chat</div>
		</div>
		<div className='mk-signup-icon'>
			<div className='mk-signup-icon-img'>
				<img
					src='https://static.wixstatic.com/shapes/dba05e_1bbf5db23ae7468185e06b95eafa5eda.svg'
					alt='knowledge-management'
				/>
			</div>
			<div>Knowledge base</div>
		</div>
		<div className='mk-signup-icon'>
			<div className='mk-signup-icon-img'>
				<img
					src='https://static.wixstatic.com/shapes/dba05e_0a8f5244c1dc40538e878e6dd6a6a09d.svg'
					alt='actionable-insights'
				/>
			</div>
			<div>Insights</div>
		</div>
	</div>
);
